import { render, staticRenderFns } from "./ModalAsignarProductosATarimaComponent.vue?vue&type=template&id=9025c43c&"
import script from "./ModalAsignarProductosATarimaComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarProductosATarimaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports